






































































































































import { Component, Vue } from 'vue-property-decorator';
import homeFooter from '@/views/home/component/footer.vue';
import Share from '@/components/shares/index.vue';
import { Getter } from 'vuex-class';
@Component({
  components: { homeFooter, Share },
})
export default class VoteDetail extends Vue {
  @Getter('user/isLogin') public isLogin: any;
  private voteCaseInfo: any = {
    voteName: '活动名称',
    totalTicket: 0,
    playerCount: 0,
    visits: 0,
    startTime: null,
    endTime: null,
    voteRules: '',
    description: '',
  };
  private isCollect: any = null;
  private isPraise: any = false;
  private voteId: any;
  private lastOrNext: any = [];
  private previewUrl: any;
  private recommendedCaseList: any = [];
  private iframePath: any = this.$subName == 'longyixiu' ? 'https://tp.longyixiu.top' : this.$subName == 'wenjuanjia' ? 'https://tp.wenjuanjia.com' : 'https://tp.longyixiu.top';
  // private iframePath: string = "http://localhost:10081";
  private caseType: any = 1; //  caseType类型  0：模板 1：案例
  private getCollectionWhether() {
    console.log(this.voteCaseInfo, 'this.voteCaseInfo');
    this.$apis
      .getCollectionWhether({
        voteId: this.voteId,
      })
      .then((res) => {
        this.isCollect = res.isCollect;
      });
  }
  private getLastOrNext() {
    this.$apis
      .getLastOrNext({
        type: 1,
        voteType: Number(this.caseType) + 1,
      })
      .then((res: any) => {
        console.log(res, '上下案例');
        this.lastOrNext = res;
      });
  }
  private handleVotePraise(status: any) {
    console.log(this.voteCaseInfo.voteId, 'this.voteCaseInfo.voteId)');
    this.$apis
      .getVotePraise({
        voteId: this.voteCaseInfo.voteId,
        praise: status,
      })
      .then((res) => {
        if (status === 1) {
          this.isPraise = true;
          this.voteCaseInfo.praiseQuantity += 1;
        } else {
          this.isPraise = false;
          this.voteCaseInfo.praiseQuantity -= 1;
        }
      });
  }
  // private toLast(voteId: any) {
  //   console.log(voteId);
  //   this.$router.push({
  //     name: "voteDetail",
  //     query: {
  //       voteId: this.$tool.encrypt(voteId),
  //       caseType: this.$route.query.caseType,
  //     },
  //   });
  // }
  private created() {
    this.voteId = this.$route.query.voteId;
    if (this.voteId) {
      this.voteId = this.$tool.decrypt(this.voteId);
    }
    this.caseType = this.$route.query.caseType; //  caseType类型  0：模板 1：案例
    // console.log("活动id", this.voteId);
    this.getVoteCaseDetail();
    this.reloadIframe();
    this.getLastOrNext();
    if (this.isLogin()) {
      this.getCollectionWhether();
    }
    this.getRecommendedCaseList();
  }
  private getRecommendedCaseList() {
    this.$apis
      .getRecommendedCaseList({
        type: 1,
        voteType: Number(this.caseType) + 1,
      })
      .then((res) => {
        this.recommendedCaseList = res;
      });
  }
  /**
   * 案例详情
   */
  private async getVoteCaseDetail() {
    if (this.voteId != null) {
      await this.$apis
        .getVoteCaseDetail({
          voteId: this.voteId,
        })
        .then((res) => {
          this.voteCaseInfo = res;

          document.title = res.voteName + '_投票评选_' + this.$globalName;
          const head: any = document.getElementsByTagName('head');
          const meta: any = document.createElement('meta');
          const keywords: any = document.querySelector('meta[name="keywords"]');
          const description: any = document.querySelector('meta[name="description"]');
          keywords.setAttribute('content', res.voteName + '投票');
          const descriptionValue: any = this.$tool.highlight(res.description);
          description.setAttribute('content', descriptionValue.slice(0, 80));
        });
    }
  }
  // private async getVoteCaseDetail() {
  //   if (this.voteId != null) {
  //     this.voteCaseInfo = await this.$apis.getVoteCaseDetail({
  //       voteId: this.voteId,
  //     });
  //     document.title = this.voteCaseInfo.voteName + "_" + this.$globalName;
  //   }
  // }

  /**
   * 时间格式
   */
  private getTimeFormat(time: any) {
    if (time != null) {
      return this.$tool.getDateTime(time, 'YYYY-MM-DD HH:MM');
    }
  }
  /**
   * 使用案例跳转
   */
  private getCreateCase(item: any) {
    // if (this.$store.getters["user/isLogin"]()) {
    //   this.$router.push("/voting/list");
    // } else {
    //   this.$router.push("/login");
    // }
    console.log(item);
    const { href } = this.$router.resolve({
      name: 'copyVote',
      query: {
        voteId: item.voteId,
      },
    });
    window.open(href, '_blank');

    // this.$router.push({
    //   path: "/voting/code",
    //   query: {
    //     voteId: item.voteId,
    //   },
    // });
  }
  /**
   * iframe 活动链接
   */
  private reloadIframe() {
    let parmas = this.$tool.encrypt(this.voteId);
    parmas = encodeURIComponent(parmas);
    this.previewUrl = `${this.iframePath}?voteId=${parmas}` + '&v=' + new Date().getTime();
  }
  // 设置收藏
  private setCollection() {
    if (this.isLogin()) {
      this.$apis
        .getCollectionSetting({
          activityType: 1,
          voteId: this.voteId,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            type: 'success',
            customClass: 'collectionMessage',
            message: `收藏成功，请在「<a  href="/collection.html"  ><span style='color:#2378ff;cursor: pointer;'>我的收藏</span></a> 」查看`,
          });
          // this.getCollectionList();
          this.isCollect = 1;
        });
    } else {
      this.$router.push('/login');
    }
  }
  // 取消收藏
  private cancelCollection() {
    if (this.isLogin()) {
      this.$apis
        .getCollectionCancel({
          voteId: this.voteId,
        })
        .then((res) => {
          // this.getCollectionList();
          this.isCollect = 0;
          this.$message({
            showClose: true,
            customClass: 'collectionMessage',
            message: `已取消收藏`,
            type: 'success',
          });
        });
    } else {
      this.$router.push('/login');
    }
  }
}
